import { EditItem, IEditItem } from "../common/editItem";
import { IModifyUser, ModifyUser } from "../user/modifyUser";

export interface IAppReportEditItem extends IEditItem {
    unitId: string;
    code: string;
    comment: string;
    dataSchema: string;
    startDate: number;
    endDate: number;
    reportData: string;
    publicUrl: string;
    isRead: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    publishUser: IModifyUser;
    archiveUser: IModifyUser;
    deleteUser: IModifyUser;
    lockedUser: IModifyUser;

    isLockedToOtherUser(userCode: string): boolean;
}

export class AppReportEditItem extends EditItem implements IAppReportEditItem {
    unitId: string;
    code: string;
    comment: string;
    dataSchema: string;
    startDate: number;
    endDate: number;
    reportData: string;
    publicUrl: string;
    isRead: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
    publishUser: IModifyUser;
    archiveUser: IModifyUser;
    deleteUser: IModifyUser;
    lockedUser: IModifyUser;

    constructor();
    constructor(obj: IAppReportEditItem);
    constructor(obj?: any) {
        super(obj);
        this.unitId = obj && obj.unitId || "";
        this.code = obj && obj.code || "";
        this.comment = obj && obj.comment || "";
        this.dataSchema = obj && obj.dataSchema || "";
        this.startDate = obj && obj.startDate || null;
        this.endDate = obj && obj.endDate || null;
        this.reportData = obj && obj.reportData || "";
        this.publicUrl = obj && obj.publicUrl || "";
        this.isRead = obj && obj.isRead || false;
        this.createUser = new ModifyUser(obj?.createUser);
        this.modifyUser = new ModifyUser(obj?.modifyUser);
        this.publishUser = obj?.publishUser ? new ModifyUser(obj.publishUser) : null;
        this.archiveUser = obj?.archiveUser ? new ModifyUser(obj.archiveUser) : null;
        this.deleteUser = obj?.deleteUser ? new ModifyUser(obj.deleteUser) : null;
        this.lockedUser = obj?.lockedUser ? new ModifyUser(obj.lockedUser) : null;
    }

    isLockedToOtherUser(userCode: string): boolean {
        return this.lockedUser?.code && !userCode.equalIgnoreCase(this.lockedUser.code);
    }
}